/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Nav_LeadershipInputs */

const en_landing_nav_leadership = /** @type {(inputs: Landing_Nav_LeadershipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leadership`)
};

/**
* | output |
* | --- |
* | "Leadership" |
*
* @param {Landing_Nav_LeadershipInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_nav_leadership = /** @type {((inputs?: Landing_Nav_LeadershipInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Nav_LeadershipInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_nav_leadership(inputs)
});